export default {
  namespace: 'brandList',
  state: {
    list: [1111],
  },
  reducers: {
    save(state, {payload: {data}}) {
      return {...data};
    },
    removeItem(state, {item}) {
      state.list = state.list.filter(function (lItem) {
        return item.id !== lItem.id;
      });
      return {...state};
    },
  },
  //effects指的是涉及到异步请求的方法。通常用来调用服务获取数据。
  //这里要注意如果effects的方法名与reducers中存在重复的话容易造成死循环。
  effects: {
    //put,  call
    *fetch(payload, {put}) {
      const data = {list: [1, 2, 3, 4]}; //yield call(userService.fatchData);

      yield put({type: 'save', payload: data});
    },
    *fetchRemoveItem(payload, {put}) {
      const result = {list: [1, 2, 3, 4, 5, 6, 7]}; //yield call(userService.fetchRemoveItem, item.id);

      yield put({type: 'removeItem', result});
    },
  },
  subscriptions: {
    // setup({dispatch}) {
    //   dispatch({type: 'fetch'});
    // },
  },
};
